import React from 'react';
import appLogo from '../.././wesko-eLock_logo.jpeg';
import '../../stylesheet/header.css';

export default function LogoHeader(props) {  
  return (
    <nav style={{width: props.hasOwnProperty('parent') ? '100%' : null, color: '#0000008A'}}>
      <div className="div-header">
        <img
          className="logo-img"
          style={{
            padding: props.hasOwnProperty('parent') ? '0px' : '4px',
            marginLeft: props.hasOwnProperty('parent') ? null : '20px',
            marginRight:"auto",
            cursor:"auto"
          }}
          src={appLogo}
          alt="logo"            
        />          
      </div>
    </nav>
  );
};